
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.269","height":"19.818"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#2684ff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}},[_c('path',{attrs:{"d":"M10.127 15.571l2.275 3.6 2.953-3.6"}}),_c('path',{attrs:{"d":"M3.781.65v2.6a6.126 6.126 0 003.012 5.277l2.63 1.553a6.126 6.126 0 013.012 5.275v3.67M6.143 15.571l-2.275 3.6-2.953-3.6"}}),_c('path',{attrs:{"d":"M6.181 10.534a6.126 6.126 0 00-2.346 4.821v3.67M12.488.65v2.6a6.126 6.126 0 01-1.632 4.165"}})])])
          )
        }
      }
    